import api from '@config/api';
import type {
  Folder,
  CreateFolderDto,
  UpdateFolderDto,
  FolderQueryParams,
  BreadcrumbItem,
} from '../types';
import type { PaginatedResponse } from '@common/types/api';

export const folderService = {
  getFolders: async (params: FolderQueryParams): Promise<PaginatedResponse<Folder>> => {
    const response = await api.get('/folders', { params });
    return response.data;
  },

  getFolder: async (id: string): Promise<Folder> => {
    const response = await api.get(`/folders/${id}`);
    return response.data;
  },

  getBreadcrumb: async (id: string): Promise<BreadcrumbItem[]> => {
    const response = await api.get(`/folders/${id}/breadcrumb`);
    return response.data;
  },

  createFolder: async (data: CreateFolderDto): Promise<Folder> => {
    const response = await api.post('/folders', data);
    return response.data;
  },

  updateFolder: async (id: string, data: UpdateFolderDto): Promise<Folder> => {
    const response = await api.patch(`/folders/${id}`, data);
    return response.data;
  },

  deleteFolder: async (id: string): Promise<void> => {
    await api.delete(`/folders/${id}`);
  },

  getSharedFolders: async (params?: FolderQueryParams): Promise<PaginatedResponse<Folder>> => {
    const response = await api.get('/folders/shared-with-me', { params });
    return response.data;
  },
};
